import { Box } from '@components/gassan-ui'
import { theme } from '@gassan-ui'
import { PrivilegeCartItem } from '@generated'
import { useRemovePrivilegeItemFromCart } from '@lib/hooks/use-remove-privilege-item-from-cart'
import { AnimatePresence } from 'framer-motion'
import { FC } from 'react'
import LoadingRow from '../LoadingRow'
import { CartPrivilegeItemListItem } from './Item'

type Props = {
  items: PrivilegeCartItem[]
  loadingRow: string | null
}

const CartPrivilegeItemList: FC<Props> = ({ loadingRow, items }) => {
  const { removePrivilegeItemFromCart } = useRemovePrivilegeItemFromCart()

  return (
    <Box
      pt={{ _: '1rem', small: '1.75rem', xlarge: '2rem' }}
      borderTop={`1px solid ${theme.colors.shades[200]}`}
    >
      {items ? (
        <AnimatePresence>
          {items.map((item) => {
            return (
              <CartPrivilegeItemListItem
                key={item.id}
                onRemove={removePrivilegeItemFromCart}
                {...item}
              />
            )
          })}
        </AnimatePresence>
      ) : (
        [...Array(1)].map((_, key) => <LoadingRow key={key} />)
      )}
    </Box>
  )
}

export default CartPrivilegeItemList
